var React = require('react');

function SearchGray (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Search"},[React.createElement("path",{"id":"Vector","fillRule":"evenodd","clipRule":"evenodd","d":"M7.75496 2C10.8543 2 13.3666 4.51231 13.3666 7.61167C13.3666 10.7111 10.8543 13.224 7.75496 13.224C4.65556 13.224 2.14325 10.7111 2.14325 7.61167C2.14325 4.51231 4.65556 2 7.75496 2Z","stroke":"#BDBDBD","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M11.5742 11.7227L13.8576 14.0001","stroke":"#BDBDBD","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

SearchGray.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SearchGray;

SearchGray.default = SearchGray;
